// Pure pub-key heuristics — no Gun dependency, safe to import from anywhere
// (including feature components, which must not touch the Gun client directly).

// Heuristic: Gun pubkeys are long and often contain dots/underscores etc.
// We treat anything "very long" as not a human username.
export function looksLikePub(value: string) {
  const s = String(value || "").trim();
  if (!s) return false;
  if (s.length >= 40) return true;
  if (s.includes(".") && s.length >= 25) return true;
  return false;
}
